import * as React from "react";
const SvgFiRrProtractor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.977 11.264C21.613 5.724 16.474 1.041 10.731 1A2 2 0 0 0 9 0H7a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h2a2 2 0 0 0 1.731-1H11a11.04 11.04 0 0 0 10.368-7.3c.507-1.42.715-2.93.609-4.436m-4.409 6.887A8.91 8.91 0 0 1 11 21h-1a1 1 0 0 0-1 1H7a2 2 0 0 1-2-2v-1h1a1 1 0 0 0 0-2H5v-2h1a1 1 0 0 0 0-2H5v-2h1a1 1 0 0 0 0-2H5V7h1a1 1 0 0 0 0-2H5V4a2 2 0 0 1 2-2h2a1 1 0 0 0 1 1h.656c4.757 0 9.027 3.844 9.324 8.394a8.93 8.93 0 0 1-2.412 6.757M11 7a2 2 0 0 0-2 2v6a2.013 2.013 0 0 0 1.976 1.989 5.09 5.09 0 0 0 5-4.5A5 5 0 0 0 11 7m0 8V9a3 3 0 0 1 2.986 3.3A3.09 3.09 0 0 1 11 15"
    />
  </svg>
);
export default SvgFiRrProtractor;
